import { useState, forwardRef, useEffect } from "react";
import { NavLink, useParams} from 'react-router-dom';
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService.jsx';
import DatosCabezaFamilia from './DatosCabezaFamilia.jsx';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import 'react-datepicker/dist/react-datepicker.css';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import DataTable from 'react-data-table-component';
import SumOneDayDate from "../Utils/SumOneDayDate.jsx";
import MenuCaracterizacion from "./Componentes/MenuCaracterizacion.jsx";
import { FaEraser, FaHandPointLeft } from "react-icons/fa";
import { useAuth } from "../../Auth/AuthContext.jsx";
import DesplazamientoForzado from "./Hechos/DesplazamientoForzado.jsx";

function AccionesHechosVictimizantes(row, SeleccionarHecho, BorrarHecho, rol) {
        return (
            <div>
                <button type="button" onClick={() => SeleccionarHecho(row)} 
                        style={{backgroundColor: 'white', border: 'none', cursor: 'pointer'}} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Seleccionar">
                    <FaHandPointLeft size={20} color="black" />
                </button>
                {rol === '2' && <button type="button" onClick={() => BorrarHecho(row)} 
                        style={{backgroundColor: 'white', border: 'none', cursor: 'pointer'}} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Borrar">
                    <FaEraser size={20} color="black" />
                </button>}
            </div>
        );
    }
export default function HechosVictimizantes(){
    const { token, user, rol } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const { idCabezaFamilia } = useParams();
    const [swalProps, setSwalProps] = useState({});
    const [numedesplazamientos, setNumedesplazamientos] = useState([]);
    const [tiposlugar, setTiposlugar] = useState([]);
    const [tiposDesplazamiento, setTiposDesplazamiento] = useState([]);
    const [tiposMovilidad, setTiposMovilidad] = useState([]);
    const [causasDesplazamiento, setCausasDesplazamiento] = useState([]);
    const [causasDesplazamientoSeleccionadas, setCausasDesplazamientoSeleccionadas] = useState([]);
    const [responsableDesplazamiento, setResponsableDesplazamiento] = useState([]);
    const [responsableDesplazamientoSeleccionados, setResponsableDesplazamientoSeleccionados] = useState([]);
    const [hechosRegistrados, setHechosRegistrados] = useState([]); 
    const [municipiosdto, setMunicipiosdto] = useState([]);
    const [hechosVictimizantes, setHechosVictimizantes] = useState([]);    
    const SeleccionarHecho = async (row) => {
        let url = '';
        url = '/caracterizacion/hechos/seleccionardesplazamiento';
        const obj = {id: row.id}
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            ActualizarCausasDesplazamiento(result[0].causasdesplazamiento.map(option => ({value: option.id, label: option.cauCausa})));
            ActualizarActoresArmados(result[0].responsablesdesplazamiento.map(option => ({value: option.id, label: option.resRespondesplazamiento})));
            reset((prevValues) => ({
                ...prevValues,
                usrId: user,
                cabIdcabezafamilia: idCabezaFamilia,
                id: result[0].id,
                tipoHecho: String(result[0].tipohecho),
                regNumdesplazamientoid: 1,
                municipioDesplazamiento: result[0].reg_municipio,
                tipoMovilidad: result[0].reg_tipomovilidadid,
                tipoEntorno: result[0].reg_tipolugar,
                tipoEntornoNombre: result[0].reg_lugar,
                TipoDesplazamiento: result[0].reg_tipodesplazamientoid,
                denuncioFiscalia: result[0].reg_denuncio,
                fechaDesplazamiento: result[0].reg_fechadesplazamiento?SumOneDayDate(new Date(result[0].reg_fechadesplazamiento)):'',
            }));
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    async function BorrarHecho(row){
        const confirmDelete = await mensajeEliminar("Eliminar hecho", "¿Está seguro de que desea eliminar este hecho?");
        if (!confirmDelete) {
            return;
        }
        setCargando(true);
        let url = '';
        url = '/caracterizacion/hechos/borrardesplazamiento';
        const obj = {id: row.id, tipoHecho: row.tipohechoid, usrId: user, cabIdcabezafamilia: idCabezaFamilia}
        try {
            const response = await apiService.post(url, obj, token);
            if(response.status === 200){
                setHechosRegistrados(response.data.hechosRegistradosDTO);
                Mensaje('Borrar hechos', 'Registro borrado con exito');
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Borrar ubicacion', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Borrar ubicacion', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    const {register, handleSubmit, watch, control, setValue, reset, formState: { errors }} = useForm({
        defaultValues: {
            CausasDesplazamientoSeleccionadas: [],
            ActoresArmadosSeleccionados: []
        }
      });
    function CrearNuevoHecho(){
        reset((prevValues) => ({
            ...prevValues,
            usrId: user,
            cabIdcabezafamilia: idCabezaFamilia,
            id: 0,
            tipoHecho: '',
            regNumdesplazamientoid: 1,
            municipioDesplazamiento: 0,
            tipoMovilidad: 0,
            tipoEntorno: 0,
            tipoEntornoNombre: '',
            TipoDesplazamiento: 0,
            denuncioFiscalia: '',
            fechaDesplazamiento: new Date(new Date().getTime() - 5 * 60 * 60 * 1000),
        }))
        ActualizarCausasDesplazamiento([])
        ActualizarActoresArmados([]);
        
    }
    const ActualizarCausasDesplazamiento = causa => {
        setCausasDesplazamientoSeleccionadas(causa);
    };
    const ActualizarActoresArmados = actor => {
        setResponsableDesplazamientoSeleccionados(actor)
    };
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const onSubmit = async (data) => {
        setCargando(true);
        let url = '';
        url = (data.id === 0)?'/caracterizacion/hechos/guardardesplazamiento':'/caracterizacion/hechos/actualizardesplazamento';
        try {
            data.fechaDesplazamiento = data.fechaDesplazamiento
                ? new Date(data.fechaDesplazamiento.getTime() - data.fechaDesplazamiento.getTimezoneOffset() * 60000)
                      .toISOString()
                      .split('T')[0]
                : null;
            data.departamentoDesplazamiento = municipiosdto.find(m => m.id === data.municipioDesplazamiento).mun_departamentoid;
            data.CausasDesplazamientoSeleccionadas = causasDesplazamientoSeleccionadas;
            data.ActoresArmadosSeleccionados = responsableDesplazamientoSeleccionados;
            data.TipoDesplazamiento = data.TipoDesplazamiento === 0 ? null : data.TipoDesplazamiento; 
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                setHechosRegistrados(response.data.hechosRegistradosDTO);
                CrearNuevoHecho();
                Mensaje('Guardar hechos', 'Registro guardado con exito');
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar ubicacion', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar ubicacion', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
          setCargando(false);
        }
      };
    useEffect(() => {
        const fetchData = async () => {
            const url = '/caracterizacion/hechos/crearformulariohechos';
            const obj = {idCabezaFamilia: idCabezaFamilia}
            try {
                setCargando(true);
                const response = await apiService.post(url, obj, token);
                const result = await response.data;
                setCabezaFamiliaDatos(result.cabezafamilia);
                setMunicipiosdto(result.municipiosdto);
                setHechosRegistrados(result.hechosRegistradosDTO);
                setNumedesplazamientos(result.numerodesplazamientos);
                setTiposlugar(result.tiposlugar);
                setTiposDesplazamiento(result.tiposdesplazamiento);
                setTiposMovilidad(result.tiposmovilidad);
                setHechosVictimizantes(result.hechosvictimizantes);
                setCausasDesplazamiento(result.causasdesplazamiento.map(option => ({value: option.id, label: option.cauCausa})));
                setResponsableDesplazamiento(result.responsablesdesplazamiento.map(option => ({value: option.id, label: option.resRespondesplazamiento})));
                CrearNuevoHecho();
            } catch (error) {
               console.error('Error fetching data:', error);
            } finally {
              setCargando(false);
            }
        };
        fetchData();
    }, [idCabezaFamilia, token]);
    function mensajeEliminar(title, text) {
        return new Promise((resolve) => {
            setSwalProps({
            show: true,
            title: title,
            text: text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, eliminar',
            cancelButtonText: 'Cancelar',
            preConfirm: () => resolve(true),
            didClose: () => resolve(false),
            });
        });
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Hechos victimizantes</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} >Grupo familiar</NavLink></li>}
                        <li className="breadcrumb-item active"> Hechos victimizantes</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia} />
                    <DatosCabezaFamilia datos={CabezaFamiliaDatos} />
                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ArrowDownwardIcon style={{ color: 'white' }} />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                        style={{ backgroundColor: '#007bff', color: 'white' }}
                        >
                        <Typography>Ver todos los hechos victimizantes registrados <b>(dar click para mostrar los hechos registrados)</b></Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className="card-body table-responsive p-0">
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th>Acciones</th>
                                            <th>Id Registro</th>
                                            <th>Fecha</th>
                                            <th>Municipio</th>
                                            <th>Tipo hecho</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {hechosRegistrados.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" className="text-center">
                                                    No hay datos para mostrar
                                                </td>
                                            </tr>
                                        ) : (
                                            hechosRegistrados.map((row, idx) => (
                                                <tr key={row.id || idx}>
                                                    <td>
                                                        <div style={{ display: 'flex', gap: '8px' }}>
                                                            <button
                                                                type="button"
                                                                onClick={() => SeleccionarHecho(row)}
                                                                style={{
                                                                    backgroundColor: 'skyblue',
                                                                    color: 'black', // Font color black
                                                                    padding: '6px 12px',         // Smaller padding
                                                                    fontSize: '1rem',            // Smaller font size
                                                                    borderRadius: '6px',         // Slightly smaller radius
                                                                    border: 'none',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                }}
                                                                data-tooltip-id='tooltiparriba'
                                                                data-tooltip-content="Seleccionar"
                                                            >
                                                                <FaHandPointLeft size={20} color="black" />
                                                            </button>
                                                            {rol === '2' && (
                                                                <button
                                                                    type="button"
                                                                    onClick={() => BorrarHecho(row)}
                                                                    style={{
                                                                        backgroundColor: 'skyblue',
                                                                        color: 'black', // Font color black
                                                                        padding: '6px 12px',         // Smaller padding
                                                                        fontSize: '1rem',            // Smaller font size
                                                                        borderRadius: '6px',         // Slightly smaller radius
                                                                        border: 'none',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center'
                                                                    }}
                                                                    data-tooltip-id='tooltiparriba'
                                                                    data-tooltip-content="Borrar"
                                                                >
                                                                    <FaEraser size={20} color="black" />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td>{row.id}</td>
                                                    <td>{row.fecha}</td>
                                                    <td>{`${row.municipio}-${row.departamento}`}</td>
                                                    <td>{row.tipohecho}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                    {/* left column */}
                    <div className="col-md-12">
                        <div className="card">
                        <div className="card-header">
                            <div className="col-sm-12">
                                <div className="float-sm-right">
                                    <button type="button" className="btn btn-primary" onClick={CrearNuevoHecho}>Nuevo hecho</button>
                                </div>
                            </div>
                        </div>
                        {/* /.card-header */}
                        {/* form start */}
                        <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                            <div className="card-body">
                                
                                <input hidden {...register('usrId')}/><input hidden {...register('cabIdcabezafamilia')}/><input hidden {...register('id')}/>
                                <DesplazamientoForzado 
                                    register={register}
                                    watch={watch}
                                    setValue={setValue}
                                    control={control}
                                    errors={errors}
                                    forwardRef ={forwardRef}
                                    numedesplazamientos={numedesplazamientos}
                                    municipiosdto={municipiosdto} 
                                    tiposlugar={tiposlugar}
                                    tiposDesplazamiento={tiposDesplazamiento}
                                    tiposMovilidad={tiposMovilidad}
                                    causasDesplazamiento={causasDesplazamiento}
                                    responsableDesplazamiento={responsableDesplazamiento}
                                    causasDesplazamientoSeleccionadas={causasDesplazamientoSeleccionadas}
                                    responsableDesplazamientoSeleccionados={responsableDesplazamientoSeleccionados}
                                    ActualizarCausasDesplazamiento={ActualizarCausasDesplazamiento}
                                    ActualizarActoresArmados={ActualizarActoresArmados}
                                    hechosVictimizantes={hechosVictimizantes}
                                />
                            </div>
                            {/* /.card-body */}
                            <div className="card-footer">
                            <button type="submit" className="btn btn-primary">Guardar</button>
                            </div>
                            {/* /.card-footer */}
                        </form>
                        </div>
                        {/* /.card */}

                    </div>
                    {/*/.col (left) */}

                    </div>
                    {/* /.row */}
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" effect="solid" className="custom-tooltip" place="bottom"/>
            </section>
        </div>
    );
}